<template>
    
    <div>

    	<section 
			:class="{'outer-pad': true }"
		>

			<Table 
				:headings="tableHeadings" 
				:items="invoices" 
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:loading="loading"
				loadingText="Loading your invoices.."
				emptyLabel="You have no invoices at the moment"
				@retryInvoice="retryInvoice"
				@getInvoice="getInvoice"
			/>

		</section>

    </div>

</template>

<script>
import Vue from 'vue'
import { mapMutations } from 'vuex'
import ApiService from './../../services/api.service'
import Table from './../../components/Table.vue'
import TableButton from './../../components/Display/TableButton.vue'
var dateFormat = require('dateformat');
export default {
  	name: 'Invoices',
  	components: {
	    Table
	},
  	props: {},
  	data() {

		return {
			table: {
				pages: 1,
				page: 1, 
				count: 1
			},
			invoices: [],
			loading: true,
			hasFailed: false,
			lastWebhookUpdate: {},
			lastWebhookUpdateCheck: {},
			loadUserCount: 0,
			downloadURLs: {}
		}

	},
	computed: {

		tableHeadings () {

			return {
				created: { value: 'Created', dateFormat: 'jS M Y @ g:i a' },
				amount_text: { value: 'Amount', emptyCell: '' },
				status: { value: 'Status', component: TableButton, event: 'retryInvoice' },
				nextAttempt: { value: 'Next Attempt', dateFormat: 'jS M Y @ g:i a', emptyCell: '', hide: this.hasFailed === false },
				invoice_pdf: { value: '', component: TableButton, event: 'getInvoice' }
			}

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText','printGlobalMessage']),

		registerForUpdates ( events, callback ) {

			this.loadUserCount = 0;

			this.loadUser ( function () {

				events.forEach ( function (ev) {

					let ev2 = ev.split('.').join('-');

					this.lastWebhookUpdateCheck[ev2] = typeof this.lastWebhookUpdate[ev2] !== 'undefined' ? this.lastWebhookUpdate[ev2] : null;

				}.bind(this));

				if ( typeof callback === 'function' ) callback();

			}.bind(this));

		},

		checkForUpdates (clear) {

			if ( typeof clear !== 'undefined' ) {

				this.lastWebhookUpdateCheck = {};
				this.updateLoadingText();
				return;

			}

			if ( Object.keys( this.lastWebhookUpdateCheck ).length > 0 ) {

				let updated = false;

				Object.keys( this.lastWebhookUpdateCheck ).forEach ( function (ev) {

					let ev2 = ev.split('.').join('-');

					if ( typeof this.lastWebhookUpdate[ev2] !== 'undefined' ) {

						if ( this.lastWebhookUpdate[ev2] !== this.lastWebhookUpdateCheck[ev2] ) {

							updated = true;

						}

					}

				}.bind(this));

				if ( updated ) {

					this.lastWebhookUpdateCheck = {};
					this.updateLoadingText();
					this.loadInvoices ();

				}
				else {

					if ( this.loadUserCount < 15 ) {

						setTimeout(function () {
							++this.loadUserCount;
							this.loadUser();
						}.bind(this), 2000);

					}
					else {

						this.lastWebhookUpdateCheck = {};
						this.updateLoadingText();
						this.printGlobalMessage({ message: "It looks like we are having an issue, please refresh the page.", temp: true, colour: 'red' })

					}

				}

			}

		},

		getInvoice({_id,index}) {

			if ( this.downloadURLs[index] ) {

				window.location.assign( this.downloadURLs[index] );
				return;

			}

			this.updateLoadingText('One moment...');

			ApiService.get( 'invoices/get/' + _id )
			.then( function( info ) {

				this.updateLoadingText();
				this.downloadURLs[index] = info.data.url;
				window.location.assign( info.data.url );
				
			}.bind(this))
			.catch( function(err) {
				
				this.checkForUpdates (true);
				this.printGlobalMessage({ message: err.response.data.error, temp: true, colour: 'red' });

			}.bind(this));

		},

		retryInvoice({_id}) {

			this.updateLoadingText('One moment...');

			this.registerForUpdates ( ['invoice.updated'], function() {

				ApiService.get( 'invoices/retry/' + _id )
				.then( function( info ) {

					this.checkForUpdates ();
					
				}.bind(this))
				.catch( function(err) {
					
					this.checkForUpdates (true);
					this.printGlobalMessage({ message: err.response.data.error, temp: true, colour: 'red' });

				}.bind(this));

			}.bind(this))

		},
		loadUser ( callback ) {

			ApiService.get( 'users', null, 'Invoices' )
			.then( function( info ) {

				this.checkForUpdates ();

				if ( typeof callback === 'function' ) {

					callback();

				}

			}.bind(this))
			.catch( function(err) {
				console.log(err);
			});

		},
		loadInvoices () {

			this.loading = true;

			ApiService.get( 'invoices' )
			.then( function( info ) {

				Vue.set(this, 'invoices', info.data.invoices);
				Vue.set(this, 'hasFailed', info.data.hasFailed);

				this.loading = false;

			}.bind(this))
			.catch( function(err) {
				console.log(err);
			});

		}

	},
	created() {

		this.loadInvoices ();

	}
}
</script>